import Component from '../core/Component';
import throttle from 'lodash/throttle';

export default class History extends Component {
    constructor(element) {
        super(element);

        this.ref = {
            inner: null,
            bg: null,
        };
    }

    prepare() {
        this.scrollHandler = throttle(this.scroll);
        this.height = this.element.offsetHeight;
        this.check();
        document.addEventListener('swup:contentReplaced', this.check);
    }

    check = () => {
        if (window.innerWidth >= 1200 && window.location.pathname !== "/" ) {
            this.setState({
                enabled: true,
            });
        } else {
            this.setState({
                enabled: false,
            });
        }
    }

    enable() {
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        this.scroll();
    }

    disable() {
        window.removeEventListener('scroll', this.scrollHandler);
        this.ref.bg.style.height = "";
        this.ref.inner.style.transform = "";
        this.element.classList.remove("is-scrolled");
    }

    scroll = event => {
        this.setState({
            percent: Math.max(  Math.min(((window.scrollY) / 300) - 0.2, 1), 0),
            scrolled: window.scrollY >= 80,
        });
    }

    stateChange(changes) {
        if ("percent" in changes) {
            this.render(1 - this.state.percent);
        }
        if ("scrolled" in changes) {
            this.element.classList.toggle("is-scrolled", this.state.scrolled);
        }
        if ("enabled" in changes) {
            if (this.state.enabled) {
                this.enable();
            } else {
                this.disable();
            }
        }
    }

    render(percent) {
        const height = Math.round((this.height-28) + (28 * percent));
        const moveDistance = Math.round(-14 * (1 - percent));
        this.ref.bg.style.height = `${ height }px`;
        this.ref.inner.style.transform = `translate3d(0, ${ moveDistance }px, 0)`;
    }
}